<script setup>
import { GA } from '@/mixins/Ga';

defineProps({
    data: { type: Object, default: () => {} },
    coverColor: {
        type: String,
        default: '',
    },
});

const ga = new GA({ category: 'midBody', action: 'clicExterne' });
</script>

<template>
    <a
        :href="data.podcastUrl"
        target="_blank"
        class="Podcast relative flex h-full w-full flex-col items-center justify-center"
        v-on:click="ga.send({ label: 'podcast' })"
    >
        <Cover
            class="!absolute inset-0 h-full w-full"
            :color="coverColor"
            :data="data.cover"
        />
        <div class="Podcast__overlay absolute inset-0 rounded-xl bg-black/50" />
        <div class="Podcast__btn h-25 w-25 relative mb-5 md:mb-0 md:h-52 md:w-52">
            <svg
                v-if="landscape || tablet"
                class="fill-current text-white"
                viewBox="0 0 210 210"
            >
                <path d="M105,210A105,105,0,1,1,210,105,105.12,105.12,0,0,1,105,210ZM105,2A103,103,0,1,0,208,105,103.12,103.12,0,0,0,105,2Z" />
                <path
                    d="M121,103.83h-4.88a11.12,11.12,0,1,1-22.23,0H89a16,16,0,0,0,14.45,15.93v5.78a6.47,6.47,0,0,0-4.91,6.28h12.94a6.47,6.47,0,0,0-4.92-6.28v-5.78A16,16,0,0,0,121,103.83Z"
                />
                <path d="M116.12,89.3a11.12,11.12,0,1,0-22.23,0v14.53h22.23Z" />
            </svg>
            <svg
                v-if="portrait"
                class="fill-current text-white"
                viewBox="0 0 50 50"
            >
                <path
                    d="M33,24.45H30.7a5.22,5.22,0,0,1-10.44,0H18a7.51,7.51,0,0,0,6.79,7.48v2.72a3,3,0,0,0-2.31,3h6.08a3,3,0,0,0-2.31-3V31.93A7.52,7.52,0,0,0,33,24.45Z"
                />
                <path d="M30.7,17.62a5.22,5.22,0,0,0-10.44,0v6.83H30.7Z" />
                <path d="M25,50A25,25,0,1,1,50,25,25,25,0,0,1,25,50ZM25,2A23,23,0,1,0,48,25,23,23,0,0,0,25,2Z" />
            </svg>
        </div>
        <h5 class="Podcast__cta h5 px-22 relative mt-10 text-center text-white">{{ data.podcastCta }}</h5>
    </a>
</template>
